var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { registerBlock } from "../core";
import { smartProps, useInspectorControl, useSmartProp } from "@smartfire/gutenberg-react";
import React, { useEffect } from "react";
import { PanelBody, PanelRow, TextControl, ToggleControl } from '@wordpress/components';
function Inspector() {
    const [label, setLabel] = useSmartProp("label");
    const [isRequired, setIsRequired] = useSmartProp("isRequired");
    useEffect(() => {
        if (label === "") {
            setLabel(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
        }
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(PanelBody, { title: "Configuration champs de formulaire", initialOpen: true },
            React.createElement(PanelRow, null,
                React.createElement(TextControl, { value: label, label: "Nom du champ", help: "Sans espace doit être unique", onChange: (value) => setLabel(value) })),
            React.createElement(PanelRow, null,
                React.createElement(ToggleControl, { label: "Champ " + isRequired ? "obligatoire" : "facultatif", checked: isRequired, onChange: () => setIsRequired(!isRequired) }))));
}
function FieldBlock(_a) {
    var { block } = _a, props = __rest(_a, ["block"]);
    useInspectorControl(Inspector);
    return React.createElement(block, props);
}
export default function registerFormField(name, component, formControlOverride = false) {
    if (!formControlOverride) {
        if (component.smartProps["label"] || component.smartProps["isRequired"] || component.smartProps["type"])
            throw "type, label and isRequired are reserved smartProps for FormField";
        let block = component.Block;
        component.Block = (props) => React.createElement(FieldBlock, Object.assign({ block: block }, props));
    }
    component.smartProps = Object.assign({ label: smartProps.string.isRequired.withDefault(""), isRequired: smartProps.bool.withDefault(false), type: smartProps.string.isRequired.withDefault(component.type) }, component.smartProps);
    component.setup = Object.assign({ category: "smartform" }, component.setup);
    return registerBlock(name, component, "smartform");
}
//# sourceMappingURL=registerFormField.js.map